var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8082 2.62038C16.3619 2.17407 15.6383 2.17407 15.192 2.62038L11.7634 6.04895C11.3171 6.49527 11.3171 7.21888 11.7634 7.6652L15.192 11.0938C15.6383 11.5401 16.3619 11.5401 16.8082 11.0938C17.2545 10.6475 17.2545 9.92384 16.8082 9.47752L15.3544 8.02233C15.5676 8.00749 15.7829 7.99993 16.0001 7.99993C18.5252 7.99993 20.8093 9.02203 22.4651 10.6778C24.1209 12.3336 25.143 14.6177 25.143 17.1428C25.143 19.6678 24.1209 21.952 22.4651 23.6078C20.8093 25.2635 18.5252 26.2856 16.0001 26.2856C13.4751 26.2856 11.1909 25.2635 9.53513 23.6078C7.87935 21.952 6.85725 19.6678 6.85725 17.1428C6.85725 16.5116 6.34557 15.9999 5.71439 15.9999C5.08321 15.9999 4.57153 16.5116 4.57153 17.1428C4.57153 20.2984 5.85197 23.1571 7.91888 25.224C9.9858 27.2909 12.8445 28.5714 16.0001 28.5714C19.1557 28.5714 22.0144 27.2909 24.0813 25.224C26.1482 23.1571 27.4287 20.2984 27.4287 17.1428C27.4287 13.9872 26.1482 11.1285 24.0813 9.06157C22.0144 6.99465 19.1557 5.71422 16.0001 5.71422C15.7802 5.71422 15.5395 5.71123 15.3226 5.72352L16.8082 4.23662C17.2545 3.79031 17.2545 3.06669 16.8082 2.62038Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplayOutline);
export default __webpack_public_path__ + "static/media/replay_outline.cb1a474f67e98c7d7557e81cffff3d8c.svg";
export { ForwardRef as ReactComponent };